import { guid } from '../../../../utils/guid'
import { FormItemType } from '../../../../form/props/form-item/default.js'
import { ShopFieldNames } from '../../../../model/shop'
import translator from '../../../../translate'
import { FormInputType } from '../../../../form/props/form-item/input'

const FormItemName = {
  id: guid().uid(),
  attribute: ShopFieldNames.NAME,
  label: translator._('shop.name'),
  type: FormItemType.INPUT,
  required: true,
  disabled: false,
  hidden: false,
  inputType: FormInputType.TEXT,
}

export default FormItemName
